import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CustomerSegmentsService } from '../../../services/customer-segments.service';
import { CustomerSegmentsIface } from '../../../interfaces/customer-segments.iface';
import { MatDialog, MatPaginator } from '@angular/material';
import { RESTDataSource } from '../../../helpers/rest.datasource';
import { Subscription } from 'rxjs/Subscription';
import { filter, switchMap, tap } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-customer-segment-list',
  templateUrl: './customer-segment-list.component.html',
  styleUrls: ['./customer-segment-list.component.scss']
})
export class CustomerSegmentListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  public dataSource: RESTDataSource<CustomerSegmentsIface>;
  public displayedColumns = ['name', 'numberOfOffers', 'numberOfCustomers', 'delete'];
  public isLoadingResults = false;
  private subscription: Subscription;

  constructor(
    private customerSegmentsService: CustomerSegmentsService,
    private toastr: ToastsManager,
    public translate: TranslateService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.dataSource = new RESTDataSource(this.customerSegmentsService);
    this.subscription = this.dataSource.loading$.subscribe(state => {
      this.isLoadingResults = state;
    });
    this.paginator.pageSize = 10;
    this.loadData();
  }

  ngAfterViewInit() {
    this.paginator.page.pipe(tap(() => this.loadData())).subscribe();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadData(): void {
    this.dataSource.loadData({}, this.paginator.pageIndex, this.paginator.pageSize, '');
  }

  deleteSegment(id: string, segmentName: string, event: Event): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'CUSTOMER_SEGMENT_LIST.DELETE_DIALOG.TITLE',
          body: 'CUSTOMER_SEGMENT_LIST.DELETE_DIALOG.BODY',
          translateParams: { segmentName }
        }
      })
      .afterClosed()
      .pipe(
        filter(v => v),
        switchMap(() => this.customerSegmentsService.remove(id))
      )
      .subscribe(
        () => {
          this.loadData();
          this.toastr.info(this.translate.instant('CUSTOMER_SEGMENT_LIST.COMPONENT.SEGMENT_REMOVED'));
        },
        () => {
          this.toastr.error(
            this.translate.instant('CUSTOMER_SEGMENT_LIST.COMPONENT.TRY_AGAIN'),
            this.translate.instant('CUSTOMER_SEGMENT_LIST.COMPONENT.FAILED_TO_REMOVE')
          );
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/customer-segments/customer-segment-list/customer-segment-list.component.ts